import { createHHAxios } from '@/references/axios/axios';
import { HHAPIService } from '@/references/axios/base';
import type { AssetData } from '@/references/axios/tokens/types';
import type { AbortOptions } from '@/references/axios/types';
import type { ClientType } from '@/references/base';
import { Network } from '@/references/network';
import type { TokenWithEurPrice } from '@/references/tokens';

export class HHAPITokenService extends HHAPIService {
  constructor(
    private baseURL: string,
    private clientType: ClientType
  ) {
    super('tokens.service');
  }

  public async getAllTokens(): Promise<TokenWithEurPrice[]> {
    const instance = createHHAxios({
      baseURL: this.baseURL,
      headers: this.getClientTypeHeaders(this.clientType)
    });

    return (
      await instance.request<{ popular: AssetData[] }, { networks: Network[] }>({
        method: 'POST',
        withCredentials: true,
        url: `v1/private/assets/popular`,
        data: { networks: Object.values(Network).filter((i) => i !== Network.unknown) }
      })
    ).data.payload.popular.map((t) => ({
      name: t.name,
      decimals: t.decimals,
      symbol: t.symbol,
      address: t.address,
      iconURL: t.iconURL ?? '',
      network: t.network,
      priceEUR: t.priceEUR,
      priceChange: t.priceChange
    }));
  }

  public async searchTokens(
    searchTerm: string,
    network: Network,
    opts?: AbortOptions
  ): Promise<TokenWithEurPrice[]> {
    const instance = createHHAxios({
      baseURL: this.baseURL,
      headers: this.getClientTypeHeaders(this.clientType)
    });

    const resp = await instance.request<
      { assets: AssetData[] },
      { filter: string; network: Network }
    >({
      method: 'POST',
      withCredentials: true,
      url: '/v1/private/assets/find',
      data: { filter: searchTerm, network },
      opts
    });

    return resp.data.payload.assets.map((t) => ({
      name: t.name,
      decimals: t.decimals,
      symbol: t.symbol,
      address: t.address,
      iconURL: t.iconURL ?? '',
      network: t.network,
      priceEUR: t.priceEUR,
      priceChange: t.priceChange
    }));
  }
}
